/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateCashOutInstrumentSelection} from '../api'

export const useMutationInitiateCashOutInstrumentSelection = createReactQueryMutationHook('initiateCashOutInstrumentSelection', initiateCashOutInstrumentSelection)
